import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect } from 'react';
import ButtonComponent from '../../../component/button/button.component';
import WaitButton from '../../../component/button/waitButton.component';
import GlobalNotification from '../../../component/common/snackbar';
import DialogComponent from '../../../component/dialog/dialog.component';
import CommonInput, { CommonInputType } from '../../../component/form/common-input.component';
import i18n from '../../../i18n';
import { Reseller, TokenMetadata, Warrant } from '../../../models';
import { LOCAL_STORAGE_KEYS } from '../../../modules/cache/local-storage.constant';
import LSM from '../../../modules/cache/tool-local-storage';
import apiManage from '../../../request';
import { AuthCard } from './auth-card';
import DeleteDialog from '../../../component/dialog/delete-dialog.component';
import _ from 'lodash';
import { accountState } from '../../my-account/account-state';
import BASE_CHECK_TYPE from '../../../constants/regular.constant';
import { formatEUR } from '../../../constants/tool.fn';
import { getAuthPointI18n } from '../../../constants/tool-auth-point';
import { AuthPointSkeleton } from './auth-card-skeleton';
/**
 * 添加授权方案详情
 */
export function AuthPointInfoDialog(
    props: {
        open: boolean;
        onCancel: () => void;
        /**
         * 区分操作的是集团还是餐厅
         * @param stringId 表示餐厅或集团的string_id字段
         * @param target 为 'GROUP' | 'RESTAURANT'
         */
        operations: { stringId: string, target: string, actionType?: 'RENEWAL' };
        onConfirm: () => void;
        type: 'ADD' | 'DELETE' | 'ACTIVE';
        authInfo: Warrant;
        belongedGroup: string;
    }
): JSX.Element {
    const { open, type, operations, onCancel, onConfirm, authInfo } = props;

    // 需要修改数量
    const hasTotalNum = (
        (authInfo?.limit_point && Object.hasOwn(authInfo?.limit_point, 'total_num'))
        || (authInfo?.warrants?.[0]?.limit_point && Object.hasOwn(authInfo?.warrants?.[0]?.limit_point, 'total_num'))
    )

    // 当前授权是Fiskaly授权点并且已激活，禁止修改数量
    const isFiskalyAuthPoint = (authInfo?.code === 'AU1028' || authInfo?.warrants?.[0]?.code === 'AU1028') && (authInfo?.activation || authInfo?.warrants?.[0]?.activation);

    const [selectedDate, setSelectedDate] = React.useState<AuthSelectDate>({});
    const [symbol, setSymbol] = React.useState<'ordinary' | 'collect'>('ordinary');
    const [authArr, setAuthArr] = React.useState<Warrant[]>([]);
    const [lastExpirationdateObj, setLastExpirationdateObj] = React.useState<{ [key: string]: string }>({});
    // 二次确认弹窗
    const [deleteOpen, setDeleteOpen] = React.useState<boolean>(false);
    // 批量操作值
    const [batchActionDate, setBatchActionDate] = React.useState<{ start_date: string; end_date: string }>({ start_date: '', end_date: '' });
    // 无效日期
    const [dateError, setDateError] = React.useState<string[]>([]);
    // 自定义多少年
    const [customYear, setCustomYear] = React.useState<number | string>(1);
    // isLoading
    const [isLoading, setLoading] = React.useState<boolean>(true);

    useEffect(() => {
        if (open) {
            setCustomYear(1);
            init();
        }
    }, [open]);


    // *********************
    // Function
    // *********************

    const init = async () => {
        setSymbol(authInfo.warrants?.length ? 'collect' : 'ordinary');
        setLastExpirationdateObj({});
        setLoading(true);
        setDateError([]);
        setSelectedDate({})
        if (type === 'ADD') {

            const nowDate = {
                start_date: moment().format(moment.HTML5_FMT.DATETIME_LOCAL_MS),
                end_date: moment().add(24, 'hours').format(moment.HTML5_FMT.DATETIME_LOCAL_MS),

            }

            let obj = {};

            // $ 授权集合
            if (authInfo.warrants?.length) {
                setAuthArr(authInfo.warrants);
                authInfo.warrants?.forEach((item) => {
                    const key = `${item.code}-${item._id || ''}`
                    const showQuantity = item.warrants?.[0].limit_point && Object.hasOwn(item.warrants[0].limit_point, 'total_num');
                    if (showQuantity) {
                        obj[key] = { ...nowDate, total_num: 0 };
                    } else {
                        obj[key] = nowDate;
                    }
                })
                setBatchActionDate(nowDate);
            }
            // $ 授权点
            else {
                const showQuantity = authInfo.limit_point && Object.hasOwn(authInfo.limit_point, 'total_num');
                nowDate['total_num'] = showQuantity ? (authInfo.limit_point?.total_num || 0) : undefined;
                obj = { [`${authInfo.code}-${authInfo._id || ''}`]: nowDate };

                setAuthArr([authInfo]);
            }


            setSelectedDate(obj)
            const tasks: Promise<any>[] = [getAuthList(), getUserInfo(), getWarrantStrategy('BEST', 1, obj)];
            await Promise.all(tasks);
        } else if (type === 'DELETE') {

            // $ 相同授权汇总模式
            if (authInfo.warrants?.length) {
                setAuthArr([authInfo]);
                const totalDetail = authInfo.warrants?.map((item) => {
                    return {
                        existWarrntId: item._id || '',
                        total_num: item.limit_point?.total_num || 0
                    };
                })
                const selectDate = {
                    start_date: (authInfo.limit_point?.start_date || '') as string,
                    end_date: (authInfo.limit_point?.end_date || '') as string,
                    totalDetail
                };
                setSelectedDate({ [`${authInfo.code}-${authInfo._id || ''}`]: selectDate });
            } else {
                setAuthArr([authInfo]);
                const showQuantity = authInfo.limit_point && Object.hasOwn(authInfo.limit_point, 'total_num');
                const selectDate = {
                    start_date: (authInfo.limit_point?.start_date || '') as string,
                    end_date: (authInfo.limit_point?.end_date || '') as string,
                    total_num: showQuantity ? (authInfo.limit_point?.total_num || 0) : undefined
                };
                setSelectedDate({ [`${authInfo.code}-${authInfo._id || ''}`]: selectDate });
            }
        } else if (type === 'ACTIVE') {
            if (authInfo.warrants?.length) {
                const nowDate = {
                    start_date: moment().format(moment.HTML5_FMT.DATETIME_LOCAL_MS),
                    end_date: moment().add(24, 'hours').format(moment.HTML5_FMT.DATETIME_LOCAL_MS),
                }
                // $ 授权集合
                setAuthArr(authInfo.warrants);
                setBatchActionDate(nowDate);
                const obj = {};
                authInfo.warrants?.forEach((item) => {
                    const selectDate = {
                        start_date: (item.limit_point?.start_date || '') as string,
                        end_date: (item.limit_point?.end_date || '') as string,
                        total_num: item.limit_point?.total_num || 0
                    };
                    obj[`${item.code}-${item._id || ''}`] = selectDate;
                })
                setSelectedDate(obj)
                getAuthList()
            }
        }
        setLoading(false)
    }

    /**
     * 获取经销商余额、折扣信息
     */
    async function getUserInfo() {
        // 经销商
        if (accountState.accountType === 'RESELLER') {
            // 获取账号信息
            const userInfoRes = await apiManage.get_reseller_id_id(accountState.userInfo?._id || '');
            if (userInfoRes && !userInfoRes.error) {
                accountState.updateUserInfo(
                    {
                        ...accountState.userInfo,
                        ...userInfoRes as TokenMetadata
                    });
            }
        }
    }

    /**
     * 获取当前code授权方案所有数据
     * - 区分餐厅\集团
     */
    async function getAuthList() {
        const { code } = authInfo;
        const params = {
            string_id: operations.stringId,
            code,
            mode: 'DETAIL',
            sort_key: 'DATE',
            sort_value: '1'
        }
        if (operations.target === 'GROUP') {

        } else if (operations.target === 'RESTAURANT') {
            const result = await apiManage.get_warrant_condition(params);
            if (!result?.error) {
                // 上个授权过期点
                const lastExpirationdateObj: { [key: string]: string } = {};
                const warrants = result[0]?.warrants || [];
                result.forEach((item) => {
                    warrants.push(...(item.warrants || []));
                });
                warrants.forEach(item => {
                    if (lastExpirationdateObj[item.code || '']) {
                        lastExpirationdateObj[item.code || ''] = `${moment(item.limit_point?.end_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')}`;
                    } else {
                        lastExpirationdateObj[item.code || ''] = moment(lastExpirationdateObj[item.code || '']).isAfter(item.limit_point?.end_date)
                            ? lastExpirationdateObj[item.code || '']
                            : `${moment(item.limit_point?.end_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')}`;
                    }
                });

                setLastExpirationdateObj(lastExpirationdateObj)
            } else {
                GlobalNotification.error(i18n.t('warrant_page_msg_failed_obtain_authorization_data'));
            }
        }
    }

    // 校验选择时间
    const checkSelectDate = (params: { [key: string]: { start_date: string, end_date: string } }) => {
        const key = Object.keys(params)[0];
        const code = key.split('-')[0];
        const newObj = { ...selectedDate[key], ...params[key] };
        const { start_date, end_date } = newObj;
        if (end_date && start_date && moment(end_date).isBefore(moment(start_date))) {
            GlobalNotification.warning(i18n.t('warrant_page_msg_start_time_cannot_later_current_time_and_cannot_earlier_end_time'));
            return false;
        }
        // 校验"上个授权点的结束时间"
        const flag = lastExpirationdateObj[code] && moment(lastExpirationdateObj[code]).isAfter(moment());
        if (flag) {
            const expirationDate = moment(lastExpirationdateObj[code]).add(1, 'd').format('YYYY-MM-DD');
            if (start_date && end_date && moment(moment(start_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')).isAfter(expirationDate)) {
                GlobalNotification.warning(i18n.t('warrant_page_msg_cannot_earlier_current_time_cannot_later_last_expiration_time_unless_expired'));
                return false;
            }
        }

        setSelectedDate((s) => { return { ...s, [key]: newObj } });
        return true;
    }

    // 新增授权(单个授权点)
    const addWarrant = async () => {
        const key = `${authInfo.code}-${authInfo._id || ''}`;

        if (key && !checkSelectDate({ [key]: selectedDate[key] })) {
            return
        }
        const start_date = key ? selectedDate[key]?.start_date : '';
        const end_date = key ? selectedDate[key]?.end_date : '';
        if (!(start_date && end_date)) {
            GlobalNotification.error(i18n.t('general_text_invalid_date'))
            return
        }
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) ?? {};
        const totalNum = key && selectedDate?.[key]?.total_num !== undefined ? Number(selectedDate[key]?.total_num) : undefined
        const params = {
            string_id: operations.stringId,
            project: authInfo.project,
            code: authInfo.code,
            limit_point: {
                code: authInfo.limit_point?.code,
                start_date: start_date as unknown as Date,
                end_date: end_date as unknown as Date,
                total_num: totalNum,
                // 剩余数量： 只有 AUP1005 Fiskaly 需要传
                remaining_num: authInfo.limit_point?.code === 'AUP1005' ? totalNum : undefined
            },
            // 新增默认未激活
            activation: false,
            current_time_zone: moment.tz.guess(),
            //  计入到敏感操作记录里
            admin_id: account._id,
            admin_nickname: account.nickname,
            // 授权点价格
            price: Number(authInfo.price || 0) * Number(customYear || 1)
        }
        const result = operations.target === 'GROUP'
            ? await apiManage.create_group_warrant(params)
            : await apiManage.create_warrant(params);

        if (!result?.error) {
            onCancel();
            onConfirm();
            GlobalNotification.success(i18n.t('warrant_page_text_add_authorization_data_successfully'));
        } else {
            // 余额不足
            const details = result?.result?.details as string || '';
            if (details.includes('Insufficient balance')) {
                GlobalNotification.error(i18n.t('reseller_page_deduction_balance_error'));
            } else {
                GlobalNotification.error(i18n.t('warrant_page_text_failed_add_authorization_data'));
            }
        }

    }

    // 批量新增(授权集合)
    const addWarrantCollect = async () => {
        let invalidDate = false;
        // 获取缓存的用户信息
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) ?? {};
        // 续约需要传总价
        let totalPrice = 0;
        const warrants = authArr.map((item) => {
            const key = `${item.code}-${item._id || ''}`;
            const start_date = key ? selectedDate[key]?.start_date : '';
            const end_date = key ? selectedDate[key]?.end_date : '';
            if (!(start_date && end_date)) {
                invalidDate = true;
            }
            // 显示数量组件
            const showQuantity = (item.limit_point?.total_num !== undefined) || (item.warrants?.[0].limit_point?.total_num !== undefined);
            const total_num = Number(selectedDate[key!]?.total_num || 0);
            // 续约
            if (!authInfo.warranti18N?.code) {
                totalPrice += Number(item?.warranti18N?.price || 0);
            }
            const totalNum = showQuantity ? total_num : undefined;
            const code = item?.limit_point?.code || item.limit_point_code;
            return {
                code: item.code || 'AU1000',
                project: item.project || 'SW2P5',
                // 新增默认未激活 续约也是是未激活
                activation: false,
                // 授权点价格
                price: Number(item?.warranti18N?.price || 0) * Number(customYear || 1),
                limit_point: {
                    // $ 授权包里的授权点 item?.limit_point?.code ；续约 授权点 limit_point_code
                    code,
                    start_date: start_date as unknown as Date,
                    end_date: end_date as unknown as Date,
                    total_num: totalNum,
                    // 剩余数量： 只有 AUP1005 Fiskaly 需要传
                    remaining_num: code === 'AUP1005' ? totalNum : undefined,
                }
            }
        })
        if (invalidDate) {
            return
        }
        const params = {
            string_id: operations.stringId,
            // $ 续约 传''
            code: authInfo.warranti18N?.code,
            warrants,
            current_time_zone: moment.tz.guess(),
            //  计入到敏感操作记录里
            admin_id: account._id,
            admin_nickname: account.nickname,
            price: Number((authInfo.warranti18N?.code ? authInfo.price : totalPrice) || 0) * Number(customYear || 1)
        }
        const result = operations.target === 'GROUP'
            ? await apiManage.create_group_warrants_collection(params)
            : await apiManage.create_warrants_collection(params);
        if (!result?.error) {
            onCancel();
            onConfirm();
            GlobalNotification.success(i18n.t('warrant_page_text_add_authorization_data_successfully'));
        } else {
            // 余额不足
            const details = result?.result?.details as string || '';
            if (details.includes('Insufficient balance')) {
                GlobalNotification.error(i18n.t('reseller_page_deduction_balance_error'));
            } else {
                GlobalNotification.error(i18n.t('warrant_page_text_failed_add_authorization_data'));
            }
        }

    }

    // 删除授权
    const deleteWarrant = async () => {
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) ?? {};
        let ids = authInfo._id ? [authInfo._id] : [];
        if (symbol === 'collect') {
            ids = authInfo.warrants?.map((item) => {
                return item._id || ''
            }) || []
        }
        const params = {
            string_id: operations.stringId,
            ids,
            // 记录到敏感操作记录里
            admin_id: account._id,
            admin_nickname: account.nickname
        }

        const result = operations.target === 'GROUP'
            ? await apiManage.delete_group_warrant_ids(params)
            : await apiManage.delete_warrant_ids(params);

        if (!result?.error) {
            onCancel();
            onConfirm();
            setDeleteOpen(false);
            GlobalNotification.success(i18n.t('warrant_page_text_delete_authorization_data_successfully'));
        } else {
            GlobalNotification.error(i18n.t('warrant_page_text_failed_delete_authorization_data'));
        }


    }
    /**
     * 编辑授权点的数量值
     */
    const editWarrntNum = async () => {
        let res = { error: false };
        const key = `${authInfo.code}-${authInfo._id || ''}`;
        if (selectedDate[key]?.totalDetail !== undefined) {
            res = await new Promise<{ error: boolean }>((resplove) => {
                let pass = { error: false };
                selectedDate?.[key]?.totalDetail?.forEach(async (item, index, arr) => {
                    const currentWarrant = authInfo.warrants?.find((i) => i._id === item.existWarrntId);

                    const pathApi = await apiManage.patchWarrantTotalnum(operations.stringId, {
                        _id: item.existWarrntId!,
                        activation: currentWarrant?.activation,
                        current_time_zone: moment.tz.guess(),
                        limit_point: {
                            code: currentWarrant?.limit_point?.code,
                            start_date: currentWarrant?.limit_point?.start_date,
                            end_date: currentWarrant?.limit_point?.end_date,
                            total_num: Number(item.total_num || 0),
                            // 剩余数量： 只有 AUP1005 Fiskaly 需要传
                            remaining_num: currentWarrant?.code === 'AU1028' && !currentWarrant?.activation ? Number(item.total_num || 0) : undefined,

                        }

                    })

                    if (pathApi?.error) {
                        pass = { error: true };
                    }
                    if (arr.length - 1 === index) {
                        resplove(pass);
                    }
                })
            })

        } else {
            res = await apiManage.patchWarrantTotalnum(operations.stringId, {
                _id: authInfo._id!,
                activation: authInfo?.activation,
                current_time_zone: moment.tz.guess(),
                limit_point: {
                    code: authInfo.limit_point?.code,
                    start_date: authInfo.limit_point?.start_date,
                    end_date: authInfo.limit_point?.end_date,
                    total_num: Number(selectedDate[key!].total_num || 0),
                    // 剩余数量： 只有 AUP1005 Fiskaly 需要传
                    remaining_num: authInfo.code === 'AU1028' && !authInfo.activation ? Number(selectedDate[key!].total_num || 0) : undefined,
                }
            })
        }

        if (!res?.error) {
            onCancel();
            onConfirm();
            GlobalNotification.success(i18n.t('warrant_page_text_edit_authorization_data_successfully'));
        } else {
            GlobalNotification.error(i18n.t('warrant_page_text_failed_edit_authorization_data'));
        }
    }

    // 编辑授权点时间和状态
    const editWarrntDateAndStatus = async () => {
        if (dateError.length) {
            GlobalNotification.error(i18n.t('general_text_invalid_date'))
            return
        }
        let invalidDate = false;
        // 总价
        let totalPrice = 0;
        const warrants = authArr.map((item) => {
            const key = `${item.code}-${item._id || ''}`;
            const start_date = key ? selectedDate[key]?.start_date : '';
            const end_date = key ? selectedDate[key]?.end_date : '';
            if (!(start_date && end_date)) {
                // 日期不合法
                invalidDate = true;
            }
            // 显示数量组件
            const showQuantity = (item.limit_point?.total_num !== undefined) || (item.warrants?.[0].limit_point?.total_num !== undefined);
            const total_num = Number(selectedDate[key!]?.total_num || 0);
            // 激活
            if (!authInfo.warranti18N?.code) {
                totalPrice += Number(item?.warranti18N?.price || 0);
            }
            const totalNum = showQuantity ? total_num : undefined;
            return {
                _id: item._id,
                // 激活
                activation: true,
                // 授权点价格
                price: Number(item?.warranti18N?.price || 0) * Number(customYear || 1),
                limit_point: {
                    // $ 授权包里的授权点 item?.limit_point?.code ；续约 授权点 limit_point_code
                    code: item?.limit_point?.code || item.limit_point_code,
                    start_date: start_date as unknown as Date,
                    end_date: end_date as unknown as Date,
                    total_num: totalNum,
                    // 剩余数量： 只有 AUP1005 Fiskaly 需要传
                    remaining_num: item?.limit_point?.code === 'AUP1005' ? totalNum : undefined
                }
            }
        })
        // 日期无效
        if (invalidDate) {
            GlobalNotification.error(i18n.t('general_text_invalid_date'))
            return
        }
        const res = await apiManage.patch_warrant({
            string_id: operations.stringId,
            warrants,
            current_time_zone: moment.tz.guess(),
            price: Number((authInfo.warranti18N?.code ? authInfo.price : totalPrice) || 0) * Number(customYear || 1)
        });
        if (!res?.error) {
            onCancel();
            onConfirm();
            GlobalNotification.success(i18n.t('warrant_page_text_edit_authorization_data_successfully'));
        } else {
            GlobalNotification.error(i18n.t('warrant_page_text_failed_edit_authorization_data'));
        }
    }

    /**
     * 获取授权时间
     * @params type 最优策略时间是1年，还是自定义时间（年）
     */
    const getWarrantStrategy = async (type: 'BEST' | 'YEAR', year: number, authSelectDate?: AuthSelectDate) => {
        const allCodes = Object.keys(authSelectDate ?? selectedDate);
        const allCodesParams = allCodes.map((item) => {
            return item.split('-')[0]
        })
        const cloneSelectedDate = _.cloneDeep(authSelectDate ?? selectedDate);
        if (type === 'YEAR') {
            const date = {};
            allCodes.forEach((item) => {
                const startDate = cloneSelectedDate[item]?.start_date;
                const endDate = moment(startDate, moment.HTML5_FMT.DATETIME_LOCAL_MS).add(year, 'year').format(moment.HTML5_FMT.DATETIME_LOCAL_MS);
                date[item] = { ...cloneSelectedDate[item], start_date: startDate, end_date: endDate }
            })
            setSelectedDate((s) => { return { ...s, ...date } });
            setCustomYear(year);
        } else if (type === 'BEST') {
            const res = await apiManage.getWarrantStrategy({ account_type: operations.target, string_id: operations.stringId, codes: allCodesParams });
            if (!res?.error) {
                const date = {};
                allCodes.forEach((item) => {
                    const curData = res.find((i) => item.includes(i.code));
                    if (curData) {
                        const start_date = moment(curData?.start_date).set('h', 0).format(moment.HTML5_FMT.DATETIME_LOCAL_MS);
                        const end_date = moment(curData?.end_date).set('h', 0).format(moment.HTML5_FMT.DATETIME_LOCAL_MS);
                        date[item] = { ...cloneSelectedDate[item], start_date, end_date }
                    }
                })
                setSelectedDate((s) => { return { ...s, ...date } });
            }
        }
    }

    /**
     * 计算价格
     */
    const setPriceTotal = () => {
        const num = Number(customYear || 1);
        let authPrice = authInfo?.price || 0;
        // 续约
        if (!authInfo?.code) {
            authPrice = authArr?.reduce(((total, item) => total + (item?.warranti18N?.price || 0)), 0) || 0;
        }
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        // 原价
        const originPrice = authPrice * num;
        // 折扣
        let discount = authPrice * num * (account.reseller_discount / 100);
        // 截断保留两位小数,不四舍五入
        discount = Math.trunc(discount * 100) / 100;
        // 实付价
        let price = originPrice - discount;
        // 截断保留两位小数,不四舍五入
        price = Math.trunc(price * 100) / 100;
        return { originPrice, totalPrice: price }
    }

    const handleClick = async () => {
        const tasks: Promise<any>[] = [];
        if (type === 'ACTIVE') {
            tasks.unshift(editWarrntDateAndStatus());
        } else {
            tasks.unshift(editWarrntNum());
        }
        await Promise.all(tasks);
    }

    // *********************
    // View
    // *********************



    return (
        <DialogComponent
            open={open}
            fullWidth={true}
            heightSize={'medium'}
            onClose={() => { onCancel(); }}
            defaultHeaderProps={{
                title: i18n.t('warrant_page_text_warrant_detail'),
                rightNode: (
                    <>
                        {/* 编辑授权点的数量值 */}
                        {(type === 'DELETE' && hasTotalNum && !isFiskalyAuthPoint) || type === 'ACTIVE' ?
                            <ButtonComponent
                                variant='outlined'
                                color={'primary'}
                                handleClick={handleClick}
                                action={'SAVE'}
                                disabled={!authArr.length}
                            /> : null}
                        {/* 新增|删除 */}
                        <ButtonComponent
                            variant='outlined'
                            color={type === 'ADD' ? 'primary' : 'secondary'}
                            handleClick={async () => {
                                if (type === 'ADD') {
                                    if (dateError.length === 0) {
                                        if (symbol === 'ordinary') {
                                            await addWarrant();
                                        } else {
                                            await addWarrantCollect();
                                        }
                                    } else {
                                        GlobalNotification.error(i18n.t('general_text_invalid_date'))
                                    }
                                } else {
                                    setDeleteOpen(true);
                                }
                            }}
                            action={type === 'ADD' ? 'SAVE' : 'DELETE'}
                            disabled={!authArr.length || isLoading}
                        />
                    </>
                )
            }}
        >
            <Box className=' ' flex={1}>
                {symbol === 'collect' &&
                    <>
                        <Box display={'flex'} flex={1} >
                            <Box display={'flex'} flex={1} padding='1rem'>
                                <Box >
                                    <Typography variant='h5'>
                                        {getAuthPointI18n(authInfo?.warranti18N?.name || [])}
                                    </Typography>
                                    <Typography variant='body1' color={(theme) => { return theme.palette.secondary.main }} >
                                        {getAuthPointI18n(authInfo?.warranti18N?.description || [])}
                                    </Typography>
                                </Box>
                                {accountState.accountType === 'RESELLER' ?
                                    props.type === 'ADD' && <Box display={'flex'} flex={1} justifyContent={'space-between'} >
                                        <Box display={'flex'}>
                                            <>
                                                {
                                                    YearBtnList.map((item, key) => {
                                                        return <Box marginLeft={'1rem'} key={key}>
                                                            <WaitButton
                                                                variant='outlined'
                                                                onClick={async () => await getWarrantStrategy('YEAR', item.value)}
                                                                titleText={''}>
                                                                {item.name}
                                                            </WaitButton>
                                                        </Box>
                                                    })
                                                }
                                                <Box marginLeft={'1rem'} width={'150px'} >
                                                    <CommonInput
                                                        inputType={'INPUT'}
                                                        size={'small'}
                                                        label={i18n.t('warrant_page_text_one_year')}
                                                        value={customYear}
                                                        type={'number'}
                                                        fullWidth
                                                        onChange={async (e) => {
                                                            const selectVal = e.target.value;
                                                            setCustomYear(selectVal);
                                                            // 正整数才计算
                                                            if (selectVal && BASE_CHECK_TYPE['customYear'].regular.test(String(selectVal))) {
                                                                await getWarrantStrategy('YEAR', Number(selectVal))
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            </>
                                        </Box>

                                    </Box>
                                    :
                                    ['ADD', 'ACTIVE'].includes(props.type) && <>
                                        <Box marginLeft={'1rem'} >
                                            <WaitButton
                                                variant='outlined'
                                                onClick={async () => await getWarrantStrategy('BEST', 1)}
                                                titleText={''}>
                                                {i18n.t('warrant_page_text_optimal policy time')}
                                            </WaitButton>
                                        </Box>
                                        <Box marginLeft={'1rem'} >
                                            <WaitButton
                                                variant='outlined'
                                                onClick={async () => await getWarrantStrategy('YEAR', 1)}
                                                titleText={''}>
                                                {`1 ${i18n.t('warrant_page_text_one_year')}`}
                                            </WaitButton>
                                        </Box>
                                        <Box marginLeft={'1rem'} display={'flex'}   >
                                            <CommonInput
                                                inputType={'DATE_RANGE'}
                                                label={i18n.t('warrant_page_text_batch_settings')}
                                                rangeHandleChangePicker={(dates, error) => {
                                                    if (!error && dates) {
                                                        const start_date = dates[0] ? moment(dates[0]).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : '';
                                                        const end_date = dates[1] ? moment(dates[1]).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : '';
                                                        // 批量操作 修改子级的日期
                                                        Object.keys(selectedDate)?.forEach((auth) => {
                                                            selectedDate[auth] = { ...selectedDate[auth], start_date, end_date };
                                                        })
                                                        const res = checkSelectDate(selectedDate);
                                                        if (res) {
                                                            setBatchActionDate({ start_date, end_date });
                                                        }
                                                    }
                                                }}
                                                rangeValue={[batchActionDate.start_date ? moment(batchActionDate.start_date).toDate() : null, batchActionDate.end_date ? moment(batchActionDate.end_date).toDate() : null]}

                                            />
                                        </Box>
                                    </>}
                            </Box>

                            <Divider flexItem variant='middle' />
                        </Box>
                        {
                            accountState.accountType === 'RESELLER' && props.type === 'ADD' && authArr.length ?
                                <PriceBoxComponent
                                    showBalance
                                    originPrice={setPriceTotal().originPrice}
                                    totalPrice={setPriceTotal().totalPrice}
                                />
                                :
                                null
                        }
                    </>
                }
                {
                    isLoading ? <AuthPointSkeleton num={authArr.length} /> :
                        <>
                            {authArr?.map((item, index) => {
                                const key = `${item.code}-${item._id || ''}`;
                                // 显示数量组件
                                const showQuantity = (item.limit_point && Object.hasOwn(item.limit_point, 'total_num'))
                                    || (item.warrants?.[0].limit_point?.total_num !== undefined);

                                // 区分汇总模式
                                const values = item.warrants?.length
                                    ? item.warrants?.map((iitem) => {
                                        const total_num = selectedDate[key]?.totalDetail?.find((totalItem) => totalItem.existWarrntId === iitem._id)?.total_num || 0;
                                        return ({
                                            ...iitem.limit_point,
                                            // 已购的授权点的_id
                                            existWarrntId: iitem._id,
                                            total_num: showQuantity ? total_num : undefined,
                                            activation: iitem.activation,
                                        }) as unknown as { start_date: string, end_date: string, code: string, total_num?: number, existWarrntId?: string };
                                    })
                                    : [{
                                        code: item.code as string,
                                        start_date: key ? selectedDate[key]?.start_date : '',
                                        end_date: key ? selectedDate[key]?.end_date : '',
                                        total_num: key && showQuantity ? (selectedDate[key]?.total_num || 0) : undefined,
                                        activation: item.activation,
                                    }]
                                // 经销商端 新增授权点或者续约授权点 需要显示价格
                                const isReseller = accountState.accountType === 'RESELLER';
                                const isAddOrdinary = props.type === 'ADD' && symbol === 'ordinary';
                                const isAuthInfoValid = authInfo && !authInfo?.code;

                                return (
                                    <AuthInfoCard
                                        key={`${item.code}${index}`}
                                        authInfo={item}
                                        values={values}
                                        onChange={(params) => {
                                            checkSelectDate({ [`${item.code}-${item._id || ''}`]: params });
                                        }}
                                        disabled={props.type === 'DELETE'}
                                        onClickOptimalPolicyTime={async (type: 'BEST' | 'YEAR', year: number) => { item.code && await getWarrantStrategy(type, year,{ [`${item.code}-${item._id || ''}`]: values[0] }) }}
                                        lastExpirationdate={item.code && lastExpirationdateObj[item.code]}
                                        changecallback={(error) => {
                                            const newDateError = dateError;
                                            if (error) {
                                                newDateError.push(`${item.code}-${item._id || ''}`);
                                            } else {
                                                _.pull(newDateError, `${item.code}-${item._id || ''}`);
                                            }
                                            setDateError(newDateError);
                                        }}
                                        onDelete={() => {
                                            const cloneAuthArr = _.cloneDeep(authArr)
                                            cloneAuthArr.splice(index, 1);
                                            setAuthArr(cloneAuthArr);
                                        }}
                                        actionType={operations.actionType}
                                        showQuantity={showQuantity}
                                        onChangeNumber={(value, existWarrntId) => {
                                            setSelectedDate((s) => {
                                                const key = `${item.code}-${item._id || ''}`
                                                const newTotalDetail = s[key!]?.totalDetail?.map((totalItem) => {
                                                    if (totalItem?.existWarrntId === existWarrntId) {
                                                        totalItem.total_num = value;
                                                    }
                                                    return totalItem
                                                })
                                                const newSelect = { ...s[key], total_num: value, totalDetail: newTotalDetail };
                                                return ({ ...s, [key]: newSelect });
                                            });
                                        }}

                                        symbol={symbol}
                                        customYear={customYear}
                                        onChangeCustomYear={async (selectVal: number | string) => {
                                            setCustomYear(selectVal);
                                            // 正整数才计算
                                            if (selectVal && BASE_CHECK_TYPE['customYear'].regular.test(String(selectVal))) {
                                                await getWarrantStrategy('YEAR', Number(selectVal))
                                            }
                                        }}
                                        // 经销商端 新增授权点或者续约授权点
                                        showPrice={isReseller && (isAddOrdinary || isAuthInfoValid)}
                                    />
                                )
                            })}
                        </>
                }

                {/* 二次确认弹窗 */}
                <DeleteDialog
                    {...{
                        open: deleteOpen,
                        onCancel: () => {
                            setDeleteOpen(false);
                        },
                        onConfirm: async () => {
                            await deleteWarrant();
                        },
                        title: i18n.t(''),
                        desc: i18n.t('dinner_table_page_whether_delete'),
                    }} />
            </Box>
        </DialogComponent >
    )
}

/**
 * 授权点信息-选择日期
 */
function AuthInfoCard(props: {
    authInfo: Warrant,
    values: { start_date: string, end_date: string, code: string, total_num?: number, existWarrntId?: string, activation?: boolean }[],
    onChange: (params: { start_date: string, end_date: string, total_num?: number }) => void;
    disabled: boolean;
    onClickOptimalPolicyTime: (type: 'BEST' | 'YEAR', year: number) => Promise<void>;
    lastExpirationdate?: string;
    changecallback?: (error: boolean) => void;
    onDelete: () => void;
    actionType?: string;
    showQuantity?: boolean;
    onChangeNumber: (total_num: number, existWarrntId?: string) => void;
    symbol?: string;
    customYear?: number | string;
    onChangeCustomYear: (num: number | string) => void;
    showPrice?: boolean;

}) {

    const { authInfo, disabled, onClickOptimalPolicyTime, lastExpirationdate, changecallback, onDelete, actionType, showQuantity } = props;
    const fromData: { key: string, label: string, regularType?: string; inputType?: CommonInputType, }[] = [
        { key: 'start_date', label: i18n.t('warrant_page_text_start_time'), inputType: 'DATE' },
        { key: 'end_date', label: i18n.t('warrant_page_text_end_time'), inputType: 'DATE' },
        { key: 'state', label: i18n.t('restaurant_info_page_status') },
    ]

    useEffect(() => {
        if (props.customYear) {
            setPriceTotal()
        }
    }, [props.customYear])


    /**
     * 计算价格
     * @param num 
     */
    const setPriceTotal = () => {
        const num = Number(props.customYear || 1);
        const authPrice = Number(authInfo?.warranti18N?.price || 0);
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        // 原价
        const originPrice = authPrice * num;
        // 折扣
        let discount = authPrice * num * (account.reseller_discount / 100);
        // 截断保留两位小数,不四舍五入
        discount = Math.trunc(discount * 100) / 100;
        // 实付价
        let price = originPrice - discount;
        // 截断保留两位小数,不四舍五入
        price = Math.trunc(price * 100) / 100;
        return { originPrice, totalPrice: price }
    }

    return (
        <Card className=' ' style={{ margin: '1rem' }}>
            <Box display={'flex'}>
                <Box  >
                    <AuthCard
                        name={getAuthPointI18n(authInfo?.warranti18N?.name || [])}
                        price={authInfo?.warranti18N?.price}
                        startDate={authInfo?.start_date}
                        endDate={authInfo?.end_date}
                        type={'chooser-single'}
                        showSelectBox={false}
                        selected={false}
                        disabled
                        onClick={() => { }}
                    />
                </Box>
                <Divider orientation='vertical' variant='middle' flexItem />
                <Box flex={1}>
                    <Box display={'flex'} flex={1} padding={'1rem'} justifyContent={'space-between'} >
                        <Box flex={1}>
                            <Box display={'flex'} flex={1}>
                                <Typography variant='h5'>
                                    {getAuthPointI18n(authInfo?.warranti18N?.name || [])}
                                </Typography>
                                {!disabled &&
                                    <>
                                        {accountState.accountType === 'RESELLER' ?
                                            props.symbol !== 'collect' &&
                                            <Box display={'flex'} flex={1} justifyContent={'space-between'}>
                                                <Box display={'flex'}>
                                                    {
                                                        YearBtnList.map((item, key) => {
                                                            return <Box marginLeft={'1rem'} key={key}>
                                                                <WaitButton
                                                                    variant='outlined'
                                                                    onClick={async () => await onClickOptimalPolicyTime('YEAR', item.value)}
                                                                    titleText={''}>
                                                                    {item.name}
                                                                </WaitButton>
                                                            </Box>
                                                        })
                                                    }
                                                    <Box marginLeft={'1rem'} width={'100px'} >
                                                        <CommonInput
                                                            inputType={'INPUT'}
                                                            size={'small'}
                                                            label={i18n.t('warrant_page_text_one_year')}
                                                            value={props.customYear}
                                                            type={'number'}
                                                            onChange={(e) => {
                                                                const selectVal = e.target.value;
                                                                props.onChangeCustomYear(selectVal)
                                                            }}
                                                        />
                                                    </Box>
                                                </Box>

                                            </Box>
                                            :
                                            <>
                                                <Box marginLeft={'1rem'} >
                                                    <WaitButton
                                                        variant='outlined'
                                                        onClick={() => onClickOptimalPolicyTime('BEST', 1)} titleText={''}>
                                                        {i18n.t('warrant_page_text_optimal policy time')}
                                                    </WaitButton>
                                                </Box>
                                                <Box marginLeft={'1rem'} >
                                                    <WaitButton
                                                        variant='outlined'
                                                        onClick={() => onClickOptimalPolicyTime('YEAR', 1)} titleText={''}>
                                                        {`1 ${i18n.t('warrant_page_text_one_year')}`}
                                                    </WaitButton>
                                                </Box>
                                            </>
                                        }</>
                                }
                            </Box>
                            <Typography variant='body1' color={(theme) => { return theme.palette.secondary.main }} >
                                {getAuthPointI18n(authInfo?.warranti18N?.description || [])}
                            </Typography>
                            <Typography variant='body1' color={(theme) => { return theme.palette.primary.main }} >
                                {lastExpirationdate && i18n.t('warrant_page_last_ckeck_point')} {lastExpirationdate}
                            </Typography>
                        </Box>

                        {/*  */}
                        {actionType === 'RENEWAL' && <Box >
                            <ButtonComponent
                                color={'secondary'}
                                variant='outlined'
                                action='DELETE'
                                handleClick={onDelete}
                            />
                        </Box>}
                    </Box>
                    {
                        props.showPrice ?
                            <PriceBoxComponent
                                showBalance={props.symbol !== 'collect'}
                                originPrice={setPriceTotal().originPrice}
                                totalPrice={setPriceTotal().totalPrice}
                            />
                            :
                            null
                    }
                    <Divider flexItem variant='middle' />
                    <Box style={{ padding: '1rem' }}>
                        <Grid container item sm={12} md={12} spacing={disabled ? 0 : 4}>
                            {props.values.map((valueItem, index) => {
                                const startDate = valueItem.start_date ? moment(valueItem.start_date).toDate() : null;
                                const endDate = valueItem.end_date ? moment(valueItem.end_date).toDate() : null;

                                // 显示数量组件(汇总模式授权判断)
                                const ItemshowQuantity = Object.hasOwn(valueItem, 'total_num') && valueItem?.total_num !== undefined;
                                return (
                                    disabled ? <Grid container key={`${index}`} >
                                        {
                                            fromData.map((item, index) => {
                                                const v = valueItem[item.key as 'start_date' | 'end_date'] || '';
                                                return <Grid item key={index}  >
                                                    <Box key={item.label + index}>
                                                        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} padding={'0.85rem'}>
                                                            <Box component='p' sx={(theme) => { return { wordBreak: 'keep-all', marginRight: '0.5rem', color: theme.palette.text.secondary } }} >
                                                                {item.label}:
                                                            </Box>
                                                            {
                                                                item.inputType === 'DATE' ?

                                                                    <Box component='p' sx={(theme) => { return { wordBreak: 'break-all', color: theme.palette.text.secondary } }} >
                                                                        {moment(v, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')}
                                                                    </Box>

                                                                    :
                                                                    <Box component='p' sx={(theme) => { return { wordBreak: 'break-all', color: theme.palette.text.secondary } }} >
                                                                        {valueItem.activation ? i18n.t('warrant_page_text_activated_default') : i18n.t('warrant_page_text_deactivated_default')}
                                                                    </Box>
                                                            }
                                                        </Box>
                                                        <Divider />
                                                    </Box>
                                                </Grid>
                                            })
                                        }
                                        {showQuantity || ItemshowQuantity ? <CommonInput
                                            style={{ marginTop: '16px' }}
                                            inputType={'INPUT'}
                                            disabled={valueItem?.activation && ['AUP1005'].includes(valueItem?.code)}
                                            label={i18n.t('immediate_num')}
                                            value={valueItem.total_num}
                                            type='number'
                                            onChange={(event: any) => {
                                                if (Number(event?.target.value) >= 0) {
                                                    props.onChangeNumber(event?.target.value, valueItem.existWarrntId);
                                                }
                                            }}
                                        /> : null}
                                    </Grid> : <Grid item key={`${index}`}>
                                        <CommonInput
                                            disabled={accountState.accountType === 'RESELLER'}
                                            inputType={'DATE_RANGE'}
                                            label={i18n.t('general_text_date_range')}
                                            rangeHandleChangePicker={(dates, error) => {
                                                changecallback?.(!!error);

                                                if (!error && dates) {
                                                    const start_date = dates[0] ? moment(dates[0]).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : '';
                                                    const end_date = dates[1] ? moment(dates[1]).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : '';
                                                    props.onChange({ start_date, end_date });
                                                }
                                            }}
                                            rangeValue={[startDate, endDate]}
                                        />
                                        {showQuantity ? <CommonInput
                                            style={{ marginTop: '16px' }}
                                            inputType={'INPUT'}
                                            label={i18n.t('immediate_num')}
                                            value={valueItem.total_num}
                                            type='number'
                                            onChange={(event: any) => {
                                                if (Number(event?.target.value) >= 0) {
                                                    props.onChangeNumber(event?.target.value, valueItem.existWarrntId);
                                                }
                                            }}
                                        /> : null}
                                    </Grid>
                                )
                            })}
                        </Grid >
                    </Box>
                </Box>
            </Box >
        </Card >
    )
}

/**
 * 价格组件
 * @returns 
 */

function PriceBoxComponent({ originPrice, totalPrice, showBalance }: { originPrice: number, totalPrice: number, showBalance?: boolean }) {
    return (
        <Box className='priceBox'>
            {
                showBalance ?
                    <>
                        <Typography variant='h6'>
                            {i18n.t('reseller_page_reseller_balance')}
                        </Typography>
                        <Typography
                            variant='h6'
                            color={'#7367f0'}
                            sx={{ marginLeft: '8px' }}
                        >
                            {formatEUR((accountState.userInfo as Reseller)?.balance || 0)}
                        </Typography>
                    </>
                    :
                    null
            }
            <Typography
                variant='h6'
                sx={{ marginLeft: '16px' }}
            >
                {i18n.t('general_text_price')}
            </Typography>
            <Typography variant='h6'
                color={'#7367f0'}
                sx={{ marginLeft: '8px', textDecoration: 'line-through' }}
                hidden={originPrice === totalPrice}>
                {formatEUR(originPrice)}
            </Typography>
            <Typography
                variant='h6'
                color={'#7367f0'}
                sx={{ marginLeft: '8px' }}
            >
                {formatEUR(totalPrice)}
            </Typography>
        </Box>
    )
}

type AuthSelectDate = {
    [key: string]: {
        start_date: string;
        end_date: string;
        total_num?: number;
        totalDetail?: {
            existWarrntId: string;
            total_num: number;
        }[];
        activation?: boolean;
    }
}


export const YearBtnList: Array<{ name: string, value: number }> = [
    {
        name: `1 ${i18n.t('warrant_page_text_one_year')}`,
        value: 1
    },
    {
        name: `2 ${i18n.t('warrant_page_text_one_year')}`,
        value: 2
    },
    {
        name: `10 ${i18n.t('warrant_page_text_one_year')}`,
        value: 10
    }
];